export default "__VITE_ASSET__CaYYtRUn__"